/** Display monetary model rates consistently while keeping API/storage precision intact. */
export function formatPrice(value: string | number | null | undefined): string {
  const parsed = typeof value === 'number' ? value : Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed.toFixed(2) : '0.00';
}
